import React from 'react';

function Malaysia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124044)">
        <mask
          id="mask0_800_124044"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124044)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#F7FCFF"
          />
          <rect x="0.0305176" y="5" width="36" height="2.9" fill="#E31D1C" />
          <rect x="0.0305176" y="10.2" width="36" height="2.9" fill="#E31D1C" />
          <rect x="0.125732" y="15.2" width="36" height="2.5" fill="#E31D1C" />
          <rect x="0.125732" y="20.2" width="36" height="2.7" fill="#E31D1C" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V2.5H0V0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H18V12H0V0Z"
            fill="#3D58DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.04273 6.20222C4.04273 7.57844 4.77198 8.87985 6.25557 8.87985C8.48147 8.87985 8.91452 8.45803 9.95317 7.87606C10.1987 8.36633 9.37045 10.4644 6.22519 10.4644C3.7094 10.4194 1.67627 8.62288 1.67627 6.20222C1.67627 3.4237 3.97529 1.92316 6.16206 1.94015C8.09259 1.94015 10.1401 2.9139 10.0774 4.15613C9.16776 3.36628 8.18007 3.36628 6.5359 3.36628C4.89173 3.36628 4.04273 4.82582 4.04273 6.20222Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.375 7.29999L11.3321 8.65316L11.3831 7.01351L9.64457 7.56334L10.7701 6.26351L9 5.79999L10.7701 5.33646L9.64457 4.03663L11.3831 4.58646L11.3321 2.94682L12.375 4.29999L13.4179 2.94682L13.3669 4.58646L15.1054 4.03663L13.9799 5.33646L15.75 5.79999L13.9799 6.26351L15.1054 7.56334L13.3669 7.01351L13.4179 8.65316L12.375 7.29999Z"
            fill="#FECA00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124044">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Malaysia;
